export default __webpack_public_path__ + "static/media/yellow_trapezium.a46890f3.png";